import { Component, Prop, Vue } from 'vue-property-decorator';
import {  itiHttpService, itiSignalRService, i18n, itiMessageService } from '@/iti-core-vue';
import DxList from 'devextreme-vue/list';
import collaborativeAreaModule from '@/store/modules/collaborative-area.module';
import { Rol } from '@/shared/dtos/rol';

@Component({
    components: {    
        DxList    
    },
})
export default class UsersByCollaborativeArea extends Vue {    
    
    @Prop() public idArea!: number;    

    public get users() { 
        return collaborativeAreaModule.usersAndRolesArea;
    }

    public get collaborativeArea() {        
        return collaborativeAreaModule.selectedCollaborativeArea;
      }

    public mounted() {
        if (!isNaN(this.idArea) && this.idArea != 0) {
            collaborativeAreaModule.getUsersAndRolesByAmbitId(this.idArea).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});            
        }                                
    } 

    public setNameUser(e: string) {
        if (e == null) return this.$tc('collaborative-area.unnamedUser');
        else return e;
    }

    public setRoleDescription(rol: Rol) {
        if(rol != null) {
          return this.$tc('roles-collaborative-area.' + rol.name);     
        }
    }
}
